import React, { useState, useEffect } from "react";
import SideBar from "../../components/SideBar";
import Header from "../../components/Header";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import CategoryForm from "./categoryform";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

function Category() {
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [open, setOpen] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 8;
  const [totalPages, setTotalPages] = useState(0);

  // State for delete confirmation dialog
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Menu_category/all`);
      if (response.status === 200 && response.data.status === "Success") {
        setCategories(response.data.items || []);
        setTotalPages(Math.ceil(response.data.total_items / rowsPerPage));
      } else {
        setError(response.data.status_message || "Failed to fetch categories.");
      }
    } catch (err) {
      setError("An error occurred while fetching categories.");
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterText]);

  const filteredCategories = categories.filter((category) =>
    category.category_name.toLowerCase().includes(filterText.toLowerCase())
  );
  const displayedItems = filteredCategories.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
    setCurrentPage(0);
  };

  const handleOpen = () => {
    setSelectedCategory(null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditCategory = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    setSelectedCategory(category);
    setOpen(true);
  };

  const handleDeleteCategory = (categoryId) => {
    setCategoryToDelete(categoryId);
    setDeleteDialogOpen(true); // Open the delete confirmation dialog
  };

  const confirmDeleteCategory = async () => {
    if (!categoryToDelete) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Menu_category/soft_delete/${categoryToDelete}`
      );

      if (response.status === 200 && response.data.status === "Success") {
        toast("Category deleted successfully!");
        fetchData();
      } else {
        setError(response.data.status_message || "Failed to delete category.");
      }
    } catch (err) {
      setError("An error occurred while deleting the category.");
    } finally {
      setDeleteDialogOpen(false); // Close the delete confirmation dialog
      setCategoryToDelete(null);
    }
  };

  const cancelDeleteCategory = () => {
    setDeleteDialogOpen(false); // Close the delete confirmation dialog without doing anything
    setCategoryToDelete(null);
  };

  return (
    <>
      <SideBar />
      <Header />
      <div className="MainContainer">
        <div className="MenuHeader">
          <div className="CategoryFilter">
            <TextField
              label="Filter by name"
              size="small"
              variant="outlined"
              fullWidth
              value={filterText}
              onChange={handleFilterChange}
            />
          </div>
          <div className="ADDBUTTON">
            <Button variant="contained" color="primary" onClick={handleOpen}>
              Add Category
            </Button>
          </div>
        </div>
        {error && <div className="error">{error}</div>}
        <div className="MenuList">
          <table>
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Category Name</th>
                <th>Status</th>
                <th className="Actionsss">Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedItems.length > 0 ? (
                displayedItems.map((category, index) => (
                  <tr key={category.id}>
                    <td>{index + 1 + currentPage * rowsPerPage}</td>
                    <td>{category.category_name}</td>
                    <td>{category.status === "1" ? "Active" : "Inactive"}</td>
                    <td className="Actionsss">
                      <Button
                        onClick={() => handleEditCategory(category.id)}
                        color="primary"
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        onClick={() => handleDeleteCategory(category.id)}
                        color="secondary"
                      >
                        <DeleteIcon />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No categories found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          {currentPage > 0 && (
            <button onClick={() => handlePageChange(currentPage - 1)}>
              Previous
            </button>
          )}
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          {currentPage + 1 < totalPages && (
            <button onClick={() => handlePageChange(currentPage + 1)}>
              Next
            </button>
          )}
        </div>

        {/* Delete Confirmation Dialog */}
        <Dialog open={deleteDialogOpen} onClose={cancelDeleteCategory}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this category?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelDeleteCategory} color="secondary">
              Cancel
            </Button>
            <Button onClick={confirmDeleteCategory} color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add/Edit Category Dialog */}
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>
            {selectedCategory ? "Edit Category" : "Add New Category"}
          </DialogTitle>
          <DialogContent>
            <CategoryForm
              closeModal={handleClose}
              fetchCategories={fetchData}
              selectedCategory={selectedCategory}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default Category;
